import React, { useEffect } from "react";
import { useFetch } from "../../../core/components/crud/contexts/fetch.context";
import { ActiveProgramStats } from "common/build/api-parameters/users";
import Spinner from "../../layout/Spinner";
import { ProgrammesBlankSlate } from "../ProgrammesBlankSlate";
import { useNavigate } from "react-router-dom";
import { useNextSession } from "../../../hooks/useNextSession";

export const PreparePage = (): JSX.Element => {
    const { fetchItem, fetching } = useFetch<ActiveProgramStats>();
    const { nextSessionId } = useNextSession();
    const navigate = useNavigate();

    useEffect(() => {
        void fetchItem(0);
    }, []);

    useEffect(() => {
        if (!fetching && nextSessionId) {
            navigate(`/prepare-session/${nextSessionId}`, { replace: true });
        }
    }, [fetching, nextSessionId, navigate]);

    if (fetching) {
        return <Spinner />;
    }

    return (
        <ProgrammesBlankSlate
            title="Prepare Sessions"
            description="You don't have any programmes created yet. Get started by creating one to prepare your sessions."
        />
    );
};

export default PreparePage;
